"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es.symbol.description.js");
var _react = _interopRequireDefault(require("react"));
var _APIConsumerCard = require("./APIConsumerCard/APIConsumerCard");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
/**
 * Global components
 * By Bhargav Shivaprasad <bshivaprasad@svb.com> (www.svb.com)
 * Summary
 * This component renders an SVB API Consumer Card
 */

/**
 * 
 * @param data - array of objects contains title, headerTitle, description, color etc. 
 * @returns API Consumer Card
 */
const SVBApiConsumerCard = props => {
  var _props$data, _props$title;
  const data = (_props$data = props === null || props === void 0 ? void 0 : props.data) !== null && _props$data !== void 0 ? _props$data : [];
  const title = (_props$title = props === null || props === void 0 ? void 0 : props.title) !== null && _props$title !== void 0 ? _props$title : "";
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "col-md-12"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "container row"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "d-flex flex-column align-items-center pb-6"
  }, /*#__PURE__*/_react.default.createElement("h1", {
    className: "heading-xxlarge api-consumer-card-title-color font-family-roboto"
  }, title), /*#__PURE__*/_react.default.createElement("div", {
    className: "api-consumer-card-main-highlighter mt-3"
  })), (data === null || data === void 0 ? void 0 : data.length) > 0 && data.map(item => /*#__PURE__*/_react.default.createElement("div", {
    className: "col-md-auto"
  }, /*#__PURE__*/_react.default.createElement(_APIConsumerCard.APIConsumerCard, {
    title: item === null || item === void 0 ? void 0 : item.title,
    description: item === null || item === void 0 ? void 0 : item.description,
    headerTitle: item === null || item === void 0 ? void 0 : item.headerTitle,
    buttonText: item === null || item === void 0 ? void 0 : item.buttonText,
    handleButtonPress: item === null || item === void 0 ? void 0 : item.handleButtonPress,
    color: item === null || item === void 0 ? void 0 : item.color
  })))));
};
var _default = SVBApiConsumerCard;
exports.default = _default;